// Paleta e ícones da matriz de incompatibilidade, compartilhados entre a grade e a
// legenda do modal: o chip da legenda precisa ser o MESMO ícone da célula, senão a
// legenda deixa de explicar a grade.
import { pxToRem } from '../../utils'

export const ink = {
  strong: '#33424b',
  soft: '#6b7a83',
  head: '#e7edf0',
  headHover: '#d7e2e8',
  line: '#dfe6ea',
  okBg: '#f1f6f2',
  okInk: '#2f7d4f',
  staleInk: '#6b5200',
  surface: '#f7f9fa'
}

// Ícone desenhado em CSS (background data-URI), não em nó SVG por célula: com N=150
// seriam 22.500 SVGs a mais na árvore. Aqui são três regras estáticas.
const svgIcon = markup => `url("data:image/svg+xml;charset=utf-8,${markup}")`

export const CHECK_ICON = svgIcon(
  "%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' " +
    "stroke='%232f7d4f' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'" +
    "%3E%3Cpath d='M4.6 12.9l5.1 5.1L19.4 6.4'/%3E%3C/svg%3E"
)

export const ALERT_ICON = svgIcon(
  "%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' " +
    "stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'" +
    "%3E%3Cpath d='M12 4.4L21.4 20.6H2.6z'/%3E%3Cpath d='M12 10.2v4.1'/%3E" +
    "%3Cpath d='M12 17.4h.01'/%3E%3C/svg%3E"
)

export const QUESTION_ICON = svgIcon(
  "%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' " +
    "stroke='%236b5200' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'" +
    "%3E%3Ccircle cx='12' cy='12' r='9'/%3E" +
    "%3Cpath d='M9.5 9.6a2.5 2.5 0 1 1 3.1 2.9c-.6.2-.9.7-.9 1.3v.5'/%3E" +
    "%3Cpath d='M12 17.6h.01'/%3E%3C/svg%3E"
)

// Mesma caixa da célula, em tamanho de texto: usada nos chips da legenda.
export const iconChip = (background, image) => `
  display: inline-block;
  width: ${pxToRem(18)};
  height: ${pxToRem(18)};
  margin-right: ${pxToRem(6)};
  border-radius: ${pxToRem('4px')};
  vertical-align: middle;
  background-color: ${background};
  background-image: ${image};
  background-repeat: no-repeat;
  background-position: center;
  background-size: ${pxToRem(11)} ${pxToRem(11)};
`



// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/gridStyles.js